import { useCart } from 'contexts/cart';
import useExperiment from 'hooks/common/use-experiment';

interface UseTest6571Return {
  showVariantButton: boolean;
  couponCode: string | undefined;
}

/**
 * Hook for AB Test: CDP / PDP price & variant communication
 * @see https://petsdeli.atlassian.net/browse/PT-6571
 */
const useTest6571 = (): UseTest6571Return => {
  const { variant } = useExperiment({ baseEntryId: 'YplAR7lf6pwer0YF655OU' });
  const showVariantButton = variant === 1;
  const { couponCode } = useCart();

  return {
    showVariantButton,
    couponCode: showVariantButton ? couponCode || undefined : undefined,
  };
};

export default useTest6571;
